import { useTranslate } from "@similarweb/i18n-provider";

import MCPServersContainer from "app/pages/sales-intelligence/modules/manage-integrations/containers/MCPServersContainer";
import ManagementPageHeader from "app/pages/sales-intelligence/pages/management/components/ManagementPageHeader/ManagementPageHeader";

import withSecondaryBarSet from "../../../../hoc/withSecondaryBarSet";
import ManagementPageWrapper from "../../components/ManagementPageWrapper/ManagementPageWrapper";
import { MANAGEMENT_MCP_SERVERS } from "../../translations/managementKeys";

const MCPServersPageContainer = () => {
    const { translate } = useTranslate();

    return (
        <ManagementPageWrapper>
            <ManagementPageHeader text={translate(MANAGEMENT_MCP_SERVERS)} />

            <MCPServersContainer />
        </ManagementPageWrapper>
    );
};

export default withSecondaryBarSet("SalesIntelligenceLists")(MCPServersPageContainer);
